import { Box, Container, Paper, Typography, useTheme, useMediaQuery, Alert } from '@mui/material';
import { Navigate, useLocation } from 'react-router-dom';
import LoginForm from '../components/auth/LoginForm';
import logo from '../assets/img/logo.png';
import { useAuth } from '../hooks/useAuth';

const Login = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { user } = useAuth();
  const location = useLocation();
  const registrationMessage = location.state?.message;

  // Redirect if user is already logged in
  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <Box
      sx={{
        minHeight: 'calc(100vh - 64px)', // Adjust for header height
        display: 'flex',
        alignItems: 'center',
        backgroundColor: 'background.default',
        padding: 2
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={3}
          sx={{
            padding: isMobile ? 3 : 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            borderRadius: 2,
            boxShadow: theme.shadows[3]
          }}
        >
          <img 
            src={logo} 
            alt="Total Turf Experience"
            style={{
              width: isMobile ? '150px' : '200px',
              height: 'auto',
              marginBottom: '1.5rem'
            }}
          />
          {registrationMessage && (
            <Alert severity="success" sx={{ width: '100%', mb: 3 }}>
              {registrationMessage}
            </Alert>
          )}
          <Typography 
            variant="h5" 
            component="h1" 
            gutterBottom
            sx={{
              color: theme.palette.primary.main,
              fontWeight: 'bold',
              fontSize: isMobile ? '1.5rem' : '1.75rem',
              textAlign: 'center'
            }}
          >
            WELCOME
          </Typography>
          <Typography 
            variant="body2" 
            color="text.secondary" 
            mb={3}
            sx={{
              textAlign: 'center',
              maxWidth: '80%'
            }}
          >
            Please log in to access your Total Turf Experience account
          </Typography>
          <LoginForm />
        </Paper>
      </Container>
    </Box>
  );
};

export default Login; 